/**
 * Analytics design tokens (JS mirror of the allspark CSS tokens).
 *
 * These power chart options (apexTheme.js) and the analytics-only components
 * (KpiCard, SectionCard, MetricDrawer) where we need values in JS rather than
 * Tailwind classes. Keep these in sync with rollup-allspark tokens.css.
 */

import { ANALYTICS_PROVIDER_COMPARISON_COLOR_CODE } from '../../../config/constants/analytics';

export const COLORS = {
  primary: '#6a13f4',
  primaryLight: '#833bf6',
  primaryLighter: '#c29efa',
  primaryLightest: '#f0e7fe',
  primaryDark: '#4a0dab',

  black: '#262626',
  white: '#ffffff',
  greyDarker: '#8d97ad',
  greyDark: '#cfd8dc',
  grey: '#eeeeee',
  greyLight: '#f4f5f7',
  greyLighter: '#fafafa',

  success: '#27ae60',
  successDark: '#00943e',
  danger: '#eb5757',
  dangerDark: '#ed2b2b',
  warning: '#f5a623',

  textMuted: '#6b7280',
  gridline: '#eef1f6',
};

/**
 * Categorical series palette for multi-series charts (per-provider / per-brand
 * / per-branch breakdowns). Ordered for adjacent-contrast and kept to 8 so it
 * stays legible; the chart cycles if it needs more.
 */
export const SERIES_PALETTE = [
  '#6a13f4', // primary
  '#27ae60', // green
  '#f5a623', // amber
  '#2d9cdb', // blue
  '#eb5757', // red
  '#9b51e0', // violet
  '#00bfa6', // teal
  '#ff8a3d', // orange
];

export const FONT_FAMILY =
  "'Inter', ui-sans-serif, system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif";

/** Comparison status returned by analyseit v2 (Metrics.order_comparison). */
export const COMPARISON_STATUS = {
  GAIN: 'GAIN',
  LOSE: 'LOSE',
  NEUTRAL: 'NEUTRAL',
};

/**
 * Canonical channel → colour resolver. Single source of truth so a given
 * provider/aggregator reads as the SAME colour everywhere — chart series,
 * legend dots, and expandable KPI breakdown rows. Falls back to the
 * categorical palette (by index) for ids without a brand colour.
 */
export const getChannelColor = (providerId, index = 0) =>
  ANALYTICS_PROVIDER_COMPARISON_COLOR_CODE[providerId] ||
  SERIES_PALETTE[index % SERIES_PALETTE.length];
